import { render, staticRenderFns } from "./edi-page.vue?vue&type=template&id=67105d0d"
import script from "./edi-page.vue?vue&type=script&lang=js"
export * from "./edi-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports